{
  "_comment": "[CI-LOCKED] El contenido de este archivo está bloqueado. Todas las aportaciones son bienvenidas, pero la validación de cambios se puede retrasar.",
  "ACCESS_KEY_ALT": "Alt Mayús $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Opción $1",
  "ACTIVITY_BOT_SAID_ALT": "El bot $1 dijo:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agente",
  "ACTIVITY_YOU_SAID_ALT": "Usted dijo:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Bot adjunto:",
  "ACTIVITY_CODE_ALT": "Ejemplo de código: $1",
  "ACTIVITY_CONTENT_CAUTION": "El contenido generado por IA puede ser incorrecto",
  "ACTIVITY_CODE_CAUTION": "Código generado por IA. Revíselo y utilícelo con cuidado",
  "ACTIVITY_ERROR_BOX_TITLE": "Mensaje de error",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Haga clic para interactuar.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "El mensaje es interactivo.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Uno o varios vínculos en el mensaje.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Errores de envío.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Usted adjuntó:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 archivo adjunto.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 datos adjuntos.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 datos adjuntos.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 datos adjuntos.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 datos adjuntos.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "No se pudo enviar. [Reintentar][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Enviando",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Enviado a las $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Ahora mismo",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Hace una hora",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Hace un minuto",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Hoy",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Ayer",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Error de análisis de tarjeta adaptable",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Error de representación de tarjeta adaptable",
  "ATTACHMENT_AUDIO": "Clip de audio.",
  "ATTACHMENT_CARD": "Tarjeta: $1 $2 $3",
  "ATTACHMENT_FILE": "Archivo: $1",
  "ATTACHMENT_IMAGE": "Imagen",
  "ATTACHMENT_TEXT": "Texto: $1",
  "ATTACHMENT_VIDEO": "Clip de vídeo",
  "AVATAR_ALT": "Avatar de $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Siguiente",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Anterior",
  "CITATION_MODEL_DIALOG_ALT": "Cita",
  "CLOSE_BUTTON_ALT": "Cerrar",
  "COLLAPSIBLE_GROUPING_TITLE": "Pensando…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Esto se muestra cuando el bot redacta mensajes de respuesta en un grupo si no se proporciona ningún resumen.",
  "COLLAPSE_BUTTON_LESS": "Mostrar menos",
  "COLLAPSE_BUTTON_LESS.comment": "Este es el texto de un botón de contenido adicional para contraer el grupo de mensajes. Cuando el usuario final hace clic en el botón, el grupo de mensajes se pliega.",
  "COLLAPSE_BUTTON_MORE": "Mostrar más",
  "COLLAPSE_BUTTON_MORE.comment": "Este es el texto de un botón de contenido adicional para expandir el grupo de mensajes. Cuando el usuario final hace clic en el botón, se expande el grupo de mensajes.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Conectado",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Conectando…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "No se puede conectar.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Interrupción de la red. Conectando de nuevo…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Error de representación. Compruebe la consola o póngase en contacto con el desarrollador del bot.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Se está tardando más de lo habitual en conectarse.",
  "CONNECTIVITY_STATUS_ALT": "Estado de conexión: $1",
  "COPY_BUTTON_TEXT": "Copiar",
  "COPY_BUTTON_COPIED_TEXT": "Copiado",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Enviar",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Cancelar",
  "FEEDBACK_FORM_PLACEHOLDER": "Proporcione todos los detalles que pueda, pero no incluya información privada o confidencial.",
  "FEEDBACK_FORM_TITLE": "Háblenos de su experiencia",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Descargar archivo '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Descargar el archivo '$1' de tamaño $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1' de tamaño $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Se abre en una ventana nueva; externo.",
  "RECEIPT_CARD_TAX": "Impuesto",
  "RECEIPT_CARD_TOTAL": "Total",
  "RECEIPT_CARD_VAT": "IVA",
  "REFERENCE_LIST_HEADER_ONE": "$1 referencia",
  "REFERENCE_LIST_HEADER_FEW": "$1 referencias",
  "REFERENCE_LIST_HEADER_MANY": "$1 referencias",
  "REFERENCE_LIST_HEADER_OTHER": "$1 referencias",
  "REFERENCE_LIST_HEADER_TWO": "$1 referencias",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Eliminar archivo adjunto $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Eliminar",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Un archivo",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Una imagen",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "No se puede enviar un mensaje vacío.",
  "SPEECH_INPUT_LISTENING": "Escuchando…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Micrófono desactivado",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Micrófono activado",
  "SPEECH_INPUT_STARTING": "Iniciando…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Siguiente",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Anterior",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Acciones sugeridas",
  "TEXT_INPUT_ALT": "Cuadro de entrada de mensajes",
  "TEXT_INPUT_PLACEHOLDER": "Escriba su mensaje",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Empiece a hablar...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Escuchando...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Procesamiento...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Hable para interrumpir...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Enviar",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Hablar",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Cargar archivo",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Teclado numérico del teléfono",
  "TEXT_INPUT_DROP_ZONE": "Colocar archivos",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Se ha superado la longitud del mensaje",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Solo admite entradas de un solo dígito",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 archivos adjuntos",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 archivos adjuntos",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 archivo adjunto",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 archivos adjuntos",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 archivos adjuntos",
  "TOAST_ACCORDION_FEW": "$1 notificaciones: Haga clic aquí para ver más detalles",
  "TOAST_ACCORDION_MANY": "$1 notificaciones: Haga clic aquí para ver más detalles",
  "TOAST_ACCORDION_OTHER": "$1 notificaciones: Haga clic aquí para ver más detalles",
  "TOAST_ACCORDION_TWO": "$1 notificaciones: Haga clic aquí para ver más detalles",
  "TOAST_ALT_ERROR": "Error",
  "TOAST_ALT_INFO": "Información",
  "TOAST_ALT_SUCCESS": "Correcta",
  "TOAST_ALT_WARN": "Advertencia",
  "TOAST_DISMISS_BUTTON": "Descartar",
  "TOAST_TITLE_ALT": "Notificación",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Historial de chats, presione las teclas de dirección para navegar.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "historial de chats",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "El mensaje es interactivo. Presione Mayús + Tab de 2 a 3 veces para cambiar al historial de chats. Después, haga clic en el mensaje para interactuar.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "El mensaje contiene uno o varios vínculos. Presione Mayús +Tab de 2 a 3 veces para cambiar al historial de chats. Después, haga clic en el mensaje para interactuar.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "El mensaje ha sugerido acciones. Presione Mayús + Tab de 2 a 3 veces para seleccionarlas.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "El mensaje ha sugerido acciones. Presione $1 para seleccionarlas.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "No se pudo enviar el mensaje.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Hay nuevos mensajes disponibles. Presione $1 para activar el foco en el botón \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "Más mensajes",
  "TRANSCRIPT_NEW_MESSAGES": "Mensajes nuevos",
  "TRANSCRIPT_TERMINATOR_TEXT": "Final del historial de chats",
  "TYPING_INDICATOR_ALT": "Mostrando indicador de escritura",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 está escribiendo.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 y otros usuarios están escribiendo.",
  "VIEW_CODE_BUTTON_TEXT": "Código",
  "VOTE_COMPLETE_ALT": "Comentarios registrados",
  "VOTE_COMPLETE_ALT.comment": "Esto es para el lector de pantalla. Etiqueta de un botón con iconos de pulgar hacia arriba o hacia abajo. La etiqueta se utiliza cuando se registran los comentarios.",
  "VOTE_DISLIKE_ALT": "No me gusta",
  "VOTE_LIKE_ALT": "Me gusta"
}